import { useMemo } from "react";
import { useReviewIndexRoute } from "@tecnobit-srl/route-types-review-index/lazy";
//#region src/index.ts
var useReviewsRouteTypes = () => {
	const reviewIndexRoute = useReviewIndexRoute();
	return useMemo(() => ({ ...reviewIndexRoute }), [reviewIndexRoute]);
};
//#endregion
export { useReviewsRouteTypes };
